import React from 'react';
import { products } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const FeaturedProducts = ({ onAddToCart }) => {
  return (
    <section id="tools" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-end mb-12 border-b-2 border-slate-200 pb-4">
          <div>
            <h2 className="text-4xl font-black text-slate-900 uppercase tracking-tight">Heavy Duty Arsenal</h2>
            <p className="text-slate-500 font-medium mt-2">Top-rated tools for any job size.</p>
          </div>
          <a href="#" className="hidden sm:flex text-green-700 font-bold hover:text-green-800 uppercase tracking-wide items-center">
            View All <SafeIcon icon={FiIcons.FiChevronRight} className="ml-1" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {products.map(product => (
            <div key={product.id} className="bg-white border border-slate-200 group hover:shadow-xl transition-shadow flex flex-col">
              <div className="relative aspect-w-4 aspect-h-3 bg-gray-100 overflow-hidden">
                <img src={product.image} alt={product.name} className="object-cover w-full h-48 group-hover:scale-105 transition-transform duration-300" />
                <div className="absolute top-2 left-2 bg-slate-900 text-white text-xs font-bold px-2 py-1 uppercase tracking-wider">
                  {product.category}
                </div>
              </div>
              <div className="p-5 flex flex-col flex-grow">
                <div className="flex items-center space-x-1 mb-2">
                  {[...Array(5)].map((_, i) => (
                    <SafeIcon key={i} icon={FiIcons.FiStar} className={i < Math.floor(product.rating) ? "text-lime-500 fill-current" : "text-gray-300"} size={14} />
                  ))}
                  <span className="text-xs text-gray-500 ml-1">({product.reviews})</span>
                </div>
                <h3 className="font-bold text-slate-900 text-lg mb-2 leading-tight">{product.name}</h3>
                <p className="text-sm text-gray-600 mb-4 flex-grow">{product.description}</p>
                <div className="flex items-center justify-between mt-auto pt-4 border-t border-slate-100">
                  <span className="font-black text-xl text-slate-900">${product.price}</span>
                  <button 
                    onClick={() => onAddToCart(product)}
                    className="bg-slate-900 hover:bg-green-700 text-white p-2 rounded-sm transition-colors"
                    aria-label="Add to cart"
                  >
                    <SafeIcon icon={FiIcons.FiPlus} size={20} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;